/* eslint-disable no-underscore-dangle */
import { Container } from '@mui/material';
import { metabaseLocalStorageKey } from 'apps/manage/hooks';
import useAuthenticated from 'core/data/authenticated';
import createDebug from 'debug';
import makeAPIRequest from 'lib/api-client';
import { useAuth } from 'oidc-react';
import React, { useEffect, useState } from 'react';
import styled from 'theme/styled';
import p from 'translation';

const debug = createDebug('evp:logout');

export default function Logout(): JSX.Element | null {
  const [, setAuthenticated] = useAuthenticated();
  const [error, setError] = useState<boolean>(false);
  // sign out of FusionAuth backend and remove any local/session tokens
  const { signOutRedirect } = useAuth();

  const logoutUser = async (): Promise<void> => {
    debug('Logout user...');

    // log out from the API, clearing cookies
    const res = await makeAPIRequest('/logout');
    if (res.status === 204 || res.status === 200 || res.status === 401) {
      // clear metabase jwt from local storage
      window.localStorage.removeItem(metabaseLocalStorageKey);
      setAuthenticated('unauthenticated');
      debug('User was logged out!');

      await signOutRedirect();
      return;
    }
    debug('Could not logout user %o', res);
    setError(true);
  };

  useEffect(() => {
    logoutUser();
  }, []);

  if (!error) {
    return null;
  }

  return (
    <Wrapper>
      <Container>
        <section>
          <h1>{p.t('logout.logout')}</h1>
          {error && <ErrorMessage>{p.t('logout.error.unknown')}</ErrorMessage>}
        </section>
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  margin-top: 4em;

  section {
    flex: 1;
    margin-left: 2em;
    margin-right: 2em;
  }
`;

const ErrorMessage = styled.p`
  padding: 1em;
  background: ${({ theme }) => theme.palette.error.main};
  color: ${({ theme }) => theme.palette.common.white};
  display: inline-block;
  border-radius: 0.3em;
  margin-bottom: 1em;
`;
